import { createActionTypes } from 'utils/action/actionTypes';

export const GET_DASHBOARD_DATA = createActionTypes('GET_DASHBOARD_DATA');

// Bumped by anything that changes dashboard numbers, the dashboard refetches on it
export const REFRESH_DASHBOARD = 'REFRESH_DASHBOARD';
